<template>
  <v-container fill-height class="section-max-width pa-0 pt-6">
    <v-layout column>
      <v-alert :value="showPasswordBanner" type="warning" color="warning-text" text class="warning">
        <v-layout row no-gutters>
          <div class="my-1">
            {{ this.$t("headers.password") }}
          </div>
          <v-spacer />
          <v-layout class="align-center" :wrap="xsOnly" justify-end>
            <v-btn
              text
              small
              color="warning-text"
              @click="dismissPasswordBanner()"
            >
              {{ $t("actions.dismiss") }}
            </v-btn>
            <v-btn
              class="ml-2"
              outlined
              small
              color="warning-text"
              @click="$router.push({ name: routeNames.password.name })"
            >
              {{ $t("actions.set_password") }}
            </v-btn>
          </v-layout>
        </v-layout>
      </v-alert>
      <v-layout v-if="loadingConfiguration" column justify-center align-center>
        <span class="grey--text title my-3 text-center">{{
          $t("main.loading_bookings")
        }}
        </span>
        <v-progress-circular color="primary" indeterminate />
      </v-layout>
      <v-layout v-else column>
        <ul id="dashboard-buttons">
          <li v-for="(item, index) in items" :key="index">
            <featured-navigation
              v-if="item.page && item.page.type === pageTypes.NAVIGATION && item.page.pageSpecific.featured"
              :page="item.page"
            />
            <featured-reservations
              v-else-if="authStatus && item.preconfiguredPage && item.preconfiguredPage.pageName === preconfiguredPageTypes.ACTIVITY_RESERVATIONS && item.preconfiguredPage.featured"
              :page="item.preconfiguredPage"
            />
            <featured-upcoming-events
              v-else-if="item.preconfiguredPage && item.preconfiguredPage.pageName === preconfiguredPageTypes.UPCOMING_EVENTS && item.preconfiguredPage.featured"
              :page="item.preconfiguredPage"
            />
            <div v-else class="section-padding">
              <dashboard-button
                :page="item.page"
                :preconfiguredPage="item.preconfiguredPage"
                :shareToken="item.shareToken"
              />
            </div>
          </li>
        </ul>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { getFileURL } from '@/lib/helpers/FileURLGetter'
import { pageTypes, preconfiguredPageTypes } from '@/config'
import routingMixins from '@/mixins/Routing'
import vuetifyMixins from '@/mixins/Vuetify'
import credentialMixins from '@/mixins/Credentials'
import routeNames from '@/router/routes'

export default {
  name: 'Main',
  data () {
    return {
      routeNames,
      pageTypes,
      preconfiguredPageTypes,
      showPasswordBanner: false,
    }
  },
  computed: {
    ...mapGetters({
      loadingConfiguration : 'service/loadingConfiguration',
      authStatus: 'auth/authStatus',
    }),
    ...mapState({
      dashboardItems: state => state.pages.dashboardItems,
    }),
    items () {
      if (!this.dashboardItems.length) {
        return null
      }
      const items = this.dashboardItems
      const itemsEnabled = items.filter((item) => item.enabled === true)

      return itemsEnabled
        .sort((a, b) => (a.order === b.order ? 0 : a.order > b.order ? 1 : -1))
    },
    settings () {
      return this.$store.state.me.settings
    },
  },
  methods: {
    getImageFile (id) {
      return getFileURL(id)
    },
    dismissPasswordBanner () {
      localStorage.setItem('dismissedForToken', localStorage.getItem('token'))
      this.showPasswordBanner = false
    },
  },
  watch: {
    settings: {
      immediate: true,
      handler: function (newValue, oldValue) {
        if (!newValue) {
          return
        }
        const credential = this.getCredentialFromToken(newValue.webappUserCredentials)
        const dismissedForToken = localStorage.getItem('dismissedForToken')
        if (!credential) {
          this.showPasswordBanner = false
        } else {
          if (
            (!!credential && credential.hasPassword) ||
            (!!dismissedForToken && dismissedForToken === token)
          ) {
            this.showPasswordBanner = false
          }
          else {
            this.showPasswordBanner = true
          }
        }
      },
    },
  },
  components: {
    DashboardButton: () =>
      import('@/components/view-components/webapp-pages/DashboardButton.vue'),
    FeaturedNavigation: () =>
      import('@/components/view-components/webapp-pages/FeaturedNavigation.vue'),
    FeaturedReservations: () =>
      import('@/components/view-components/webapp-pages/FeaturedReservations.vue'),
    FeaturedUpcomingEvents: () =>
      import('@/components/view-components/webapp-pages/upcoming-events/FeaturedUpcomingEvents.vue'),
  },
  mixins: [routingMixins, vuetifyMixins, credentialMixins],
}
</script>

<style lang="scss">
#dashboard-buttons {
  list-style: none;
  padding: 0;

  li {
    width: 100%;
    display: inline-block;
    padding: 10px 0 10px 0;
  }
}
</style>
